module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.controlerBtnSubmit == true) ? _c('vue-excel-xlsx', {
    staticClass: "btn btn-primary",
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "filename": 'franquias',
      "sheetname": 'sheetname'
    }
  }, [_vm._v("\n    Franquias\n  ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando Franquias...\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ea30f5e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planilha/planilhas-adm/ExportFranquias.vue
// module id = 990
// module chunks = 1